var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#FFF", fillRule: "evenodd", d: "M9.5 2a7.5 7.5 0 0 1 6.732 10.81l4.795 4.056a2.952 2.952 0 1 1-4.16 4.16l-4.057-4.794A7.5 7.5 0 1 1 9.5 2zm7.839 14.367l-.972.972 2.026 2.396a.952.952 0 1 0 1.342-1.342l-2.396-2.026zm-2.23-1.888a7.547 7.547 0 0 1-.63.63l1.24 1.464.854-.854-1.464-1.24zM9.5 4a5.5 5.5 0 1 0 0 11 5.5 5.5 0 0 0 0-11z" })
  );
});